"use strict";

exports.__esModule = true;
exports.DsButton = void 0;

require("core-js/modules/es.array.flat.js");

require("core-js/modules/es.array.unscopables.flat.js");

require("core-js/modules/web.timers.js");

require("./DsButton.css");

var _jsxRuntime = require("react/jsx-runtime");

var DsButton = function DsButton(_ref) {
  var _onClick = _ref.onClick,
      flat = _ref.flat,
      outline = _ref.outline,
      discreet = _ref.discreet,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      size = _ref.size,
      iconLabel = _ref.iconLabel,
      iconPosition = _ref.iconPosition,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? 'md' : _ref$iconSize,
      disabled = _ref.disabled,
      _ref$disabledOnClick = _ref.disabledOnClick,
      disabledOnClick = _ref$disabledOnClick === void 0 ? false : _ref$disabledOnClick,
      children = _ref.children,
      _ref$additionalClassN = _ref.additionalClassNames,
      additionalClassNames = _ref$additionalClassN === void 0 ? '' : _ref$additionalClassN,
      title = _ref.title;
  var className = "btn " + (outline ? "btn-outline-" + color : discreet ? "btn-discreet-" + color : flat ? "btn-flat-" + color : "btn-" + color) + " " + (size ? "btn-" + size : '') + " " + (iconLabel && iconPosition ? "btn-icon-" + (iconPosition === 'left' ? 'start' : 'end') : '') + " " + additionalClassNames;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
    className: className,
    disabled: disabled,
    onClick: function onClick(event) {
      if (!disabled) {
        event.preventDefault();
        event.stopPropagation();

        _onClick();

        if (disabledOnClick) {
          var buttonTarget = event.currentTarget;
          buttonTarget.disabled = true;
          setTimeout(function () {
            buttonTarget.disabled = false;
          }, 2000);
        }
      }
    },
    title: title,
    children: [iconLabel && (iconPosition === undefined || iconPosition === 'left') && /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
      className: "icon icon-" + iconSize,
      children: iconLabel
    }), children, iconLabel && iconPosition === 'right' && /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
      className: "icon icon-" + iconSize,
      children: iconLabel
    })]
  });
};

exports.DsButton = DsButton;